import { render } from "./OpportunityDetail.vue?vue&type=template&id=20cd759d&scoped=true"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"

import "./OpportunityDetail.vue?vue&type=style&index=0&id=20cd759d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20cd759d"

export default script